// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_ST_MOV_BANC = {
  Criada: 'FIN_ST_MOV_BANC1',
  Baixada: 'FIN_ST_MOV_BANC2',
  Conciliada: 'FIN_ST_MOV_BANC3',
  Estornada: 'FIN_ST_MOV_BANC4',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_ST_MOV_BANC1: 1,
    FIN_ST_MOV_BANC2: 2,
    FIN_ST_MOV_BANC3: 3,
    FIN_ST_MOV_BANC4: 4
  }
}
